import { OrderReviewReceiptComponent } from './orderReviewReceipt.component';
export { OrderReviewReceiptComponent };
